import {createSlice} from '@reduxjs/toolkit';

const cellularPackageSlice = createSlice({
  name: 'cellularPackage',
  initialState: {
    cellularProductId: {},
  },

  reducers: {
    reportAnalytics: (state, action) => {},
    setPackageCode: {
      reducer(state, action) {
        state.cellularProductId = action.payload;
      },
    },
  },
});

export const {setPackageCode, reportAnalytics} = cellularPackageSlice.actions;

export default cellularPackageSlice.reducer;
